import {STATUS_SERVICE} from '../../constants/app/services';
import INSPECTIONS_ACTIONS from '../../constants/actions/inspections';
import ta from 'time-ago';
import { INSPECTION_STATE, INSPECTION_STATE_CODE } from '../../constants/app/inspection';
const defaultState = {
	statusService: STATUS_SERVICE.INITIAL,
	inspections: [],
	total: 0,
	page: 0,
	searchFilter: '',
	searchValue: ''
}
const InspectionsReducer = (state = defaultState, { type, payload }) => {
	let inspections = [...state.inspections];
	switch(type) {
		case INSPECTIONS_ACTIONS.LOAD:
			return {
				...state,
				statusService: STATUS_SERVICE.INPROGRESS,
				inspections: [],
				total: 0,
				error: null,
				page:payload.page,
				size: payload.size,
				states: payload.states,
				searchFilter: payload.searchFilter,
				searchValue: payload.searchValue
			}
		case INSPECTIONS_ACTIONS.LOAD_OK:{
			let inspections = payload.inspections.map((item) => {
				const [documentType, documentNumber] = item.userIdentity.toUpperCase().split('-')
				return {
					...item,
					documentType,
					documentNumber,
					client: {names: '', firstSurname: '', lastSurname: ''},
					state: {inspectionStatus: 'UNDEFINED'}
				}
			});
			return {
				...state,
				statusService: STATUS_SERVICE.SUCCESS,
				total: payload.total,
				inspections
			}
		}
		case INSPECTIONS_ACTIONS.LOAD_ERROR:
			return {
				...state,
				statusService: STATUS_SERVICE.ERROR,
				error: payload,
				inspections: [],
			}
		case INSPECTIONS_ACTIONS.LOAD_CUSTOMER_OK:{
			const inspection  = inspections.find(ins => ins.id === payload.inspection.id);
			inspection.client = payload.customer;
			return {
				...state,
				inspections
			}
		}
		case INSPECTIONS_ACTIONS.LOAD_STATE_OK:{
			const inspection  = inspections.find(ins =>ins.id === payload.inspection.id);
			let sent = {};
			let create = {};
			if (payload.state && payload.state.length > 0) {
				create = payload.state.find(state =>state.inspectionStatus === INSPECTION_STATE_CODE.CREATE);
				sent = payload.state.find(state =>state.inspectionStatus === INSPECTION_STATE_CODE.SENT || state.inspectionStatus === INSPECTION_STATE_CODE.PRESENCIAL);
			}
			inspection.states = payload.state;
			inspection.lastStateSent = sent || {};
			inspection.stateCreate = create || {};
			inspection.state = payload.state[0];
			return {
				...state,
				inspections
			}
		}
		default:
			return {
				...state
			}
	}
}
export default InspectionsReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/inspections.js